module.exports = __webpack_public_path__ + "img/sns_youtube.9a1272f0.png";